import React, { Component } from 'react'
import { Router, Link, withRouter }     from 'react-static'
//
import Logo     from 'components/Logo'


export default class Navbar extends Component {
    constructor(props) {
        super(props)
        this.state = {
            open: false,
        }
    }

    toggleNav = () =>{
        // Toggles the state of the Navbar
        // Open: true shows the Navbar nav slide
        this.setState({ open: (this.state.open) ? false : true })
    }

    render(){
        return (
            <div>
                {/*  When page is scrolling down hides the Navbar unless the state is 'Open' */}
                <div className={`navbar ${( this.props.scrolling && !this.state.open ) ? 'navbar--hidden' : ''}`}>
                    <div className="container">
                        <div className="navbar__header">
                            <div className="navbar__logo"><Link exact to="/"><Logo width="150" height="20" /></Link></div>
                            <div className="navbar__label"><span>{ this.props.label }</span></div>
                            <div className="navbar__btn navbar__btn--nav" onClick={ this.toggleNav }></div>
                        </div>
                    </div>
                </div>
                <div className={`navbar__slider ${(this.state.open) ? 'navbar__slider--open' : ''}`}>
                    <div className="navbar__btn navbar__btn--close" onClick={ this.toggleNav }></div>
                    <nav>
                        <Link exact to="/" onClick={ this.toggleNav }>Home + <br/>our work</Link>
                        <Link to="/about" onClick={ this.toggleNav }>The ward</Link>
                        <Link to="/services" onClick={ this.toggleNav }>How we work</Link>
                        <Link to="/news" onClick={ this.toggleNav }>News</Link>
                        <Link to="/contact" onClick={ this.toggleNav }>Contact</Link>
                    </nav>
                </div>
            </div>
        )
    }
}




// WEBPACK FOOTER //
// /opt/build/repo/src/components/Navbar.js